//// <reference path="./declare.d.ts" />

// Vue component imports
import GnosisAddressCandidates from './gnosisAddressCandidates.vue'
//// <reference path="./declare.d.ts" />

// Vue component imports
declare const GnosisAddressValidation_WebsiteKey: string

import Vue from 'vue'

// Import vue component

// Declare install function executed by Vue.use()
export function install(Vue: any) {
	if ((install as any).installed) return;
	(install as any).installed = true;
  Vue.component('gnosis-addressCandidates', GnosisAddressCandidates)
}

// Create module definition for Vue.use()
const plugin = {
	install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


var gnosisAddressValidation = null;


interface IAddress {
    address1: string;
    address2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
    countryCode?: string;
    county?: string;
    latitude?: string;
    longitude?: string;
    vdata?: string;
    /*countyFIPS?: string;
    carrierRoute?: string;
    deliveryPointCode?: string;
    dpvCode?: string;
    verificationStatus?: string;*/
}
interface IResponse {
    addresses: IResponseAddress[];
    meta?:string;
}
interface IResponseAddress {
    Line1: string;
    Line2?: string;
    City?: string;
    State?: string;
    Zip?: string;
    CountryName?: string;
    CountryISO?: string;
    County?: string;
    Latitude?: string;
    Longitude?: string;
    IsDeliverable?: boolean; 
    IsMissingOrInvalidSecondary?: boolean;
    vData?:string;
    /*CountyFIPS?: string;
    CarrierRoute?: string;
    DeliveryPointCode?: string;
    DPVCode?: string;
    RecordResultCodes?: string;*/
}
interface ICandidateAddress extends IAddress {
    candidateIndex: number
}
class addressValidationResult {
    serviceError:boolean = false;
    error: string = '';
    isValid: boolean = false;
    isAmbiguous: boolean = false;
    isMissingOrInvalidSecondary: boolean = false;
    validatedAddress: IAddress | null = null;
    rawResult: object | null= null;
    candidateAddresses: IAddress[] | null = null;
    originalSuppliedAddress: IAddress | null = null;
    autoAcceptAddress: boolean = false;
    meta: string | null = null;
}

class addressLookup {
    line1: string = "";
    line2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    county?: string;
}
(globalThis as any).gnosisAddressValidation = {
    validateAddress: async function (address: IAddress, maxCandidates: Number): Promise<addressValidationResult> {
        var self = this;
        if (address === null) {
            address = { address1: "PO Box 4 Old Chelsea Station New York, NY 10011" }
        }
        let lookup = new addressLookup;
        lookup.line1 = address.address1;
        lookup.line2 = address.address2 || '';
        lookup.city = address.city || '';
        lookup.state = address.state || '';
        lookup.zip = address.zipCode || '';
        lookup.country = address.country || '';
        lookup.county = address.county || '';

        if (!!lookup.line1) {
       

                let res  = fetch("/gnosis-api/v1/address/verifyAddress/webKey/" + GnosisAddressValidation_WebsiteKey, {
                        method: "post",
                        headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                        },
                    
                        //make sure to serialize your JSON body
                        body: JSON.stringify(lookup)
                    }).then(function(res:Response) {
                        if (!res.ok) {
                            const avsResult = new addressValidationResult();
                            avsResult.error = res.status + ' ' + (res.statusText || '');
                            avsResult.serviceError = true;
                            avsResult.rawResult = null;
                            avsResult.isValid = false;
                            avsResult.isAmbiguous = false;
                            avsResult.isMissingOrInvalidSecondary = false;
                            avsResult.originalSuppliedAddress = address;
                            avsResult.meta = null;
                            return Promise.reject(avsResult);
                        }
                        else {
                            return self.processResponse(res, address);
                        }
                    }, function(requestError) {
                       const avsResult = new addressValidationResult();
                        avsResult.error = (requestError as any).error;
                        avsResult.serviceError = true;
                        avsResult.rawResult = null;
                        avsResult.isValid = false;
                        avsResult.isAmbiguous = false;
                        avsResult.isMissingOrInvalidSecondary = false;
                        avsResult.originalSuppliedAddress = address;
                        avsResult.meta = null;
                        return Promise.reject(avsResult);
                    })

                    return res;
        } else {
            const avRes = new addressValidationResult()
            avRes.error = "A street address is required.";
            avRes.rawResult = null;
            avRes.isValid = false;
            avRes.isAmbiguous = false;
            avRes.isMissingOrInvalidSecondary = false;
            avRes.originalSuppliedAddress = address;
            avRes.serviceError = false;
            avRes.meta = null;
 return Promise.reject(avRes)

        }
    },
    async processResponse(res:Response, address:IAddress):Promise<addressValidationResult> {
        const resJSON = await res.json()
        const addressResponse = (resJSON) as IResponse;

        const avRes = new addressValidationResult()

        const firstResult = addressResponse.addresses[0];
        avRes.rawResult = resJSON
        avRes.isValid = firstResult?.IsDeliverable ?? false;
        avRes.isAmbiguous = addressResponse.addresses.length > 1;
        avRes.isMissingOrInvalidSecondary = firstResult?.IsMissingOrInvalidSecondary ?? false;
        avRes.originalSuppliedAddress = address;
        avRes.meta = addressResponse.meta || null;
       // if (!avRes.isValid) {
           // avRes.error = "The address is invalid."
       // } else 
       if (avRes.isAmbiguous) {
            avRes.candidateAddresses = addressResponse.addresses.map( (candidate, index) => { 
                return this.rawCandidateToAddress(candidate, index) }, this)
        //} else if (avRes.isMissingSecondary) {
           //avRes.error = "The address is missing a secondary number."
        } else if (avRes.isValid) {
            const candidate = firstResult;
            if (address.address1 !== candidate.Line1 ||
                address.address2 !== candidate.Line2 ||
                address.city !== candidate.City ||
                address.state !== candidate.State ||
                address.zipCode !== candidate.Zip 
                /*||
                address.country !==  candidate.CountryName ||
                address.county !==  candidate.County ||
                address.latitude !==  candidate.Latitude ||
                address.longitude !==  candidate.Longitude 
                
                
                ||
                address.countryCode !==  candidate.CountryISO ||
                address.countyFIPS !==  candidate.CountyFIPS ||
                address.carrierRoute !==  candidate.CarrierRoute ||
                address.deliveryPointCode !==  candidate.DeliveryPointCode ||
                address.dpvCode !==  candidate.DPVCode */
            ) {
                //address was altered, user needs to verify
                avRes.validatedAddress = this.rawCandidateToAddress(candidate)
            }
            else {
                //address was unalterd, just need to provide stuff like GPS coords
                avRes.autoAcceptAddress = true;
                avRes.validatedAddress = this.rawCandidateToAddress(candidate)
            }

        }
        else {
          //  avRes.error = "Unknown Error"
        }
        return Promise.resolve(avRes)

    },
    rawCandidateToAddress: function (candidate:IResponseAddress, setCandidateIndex?: number): IAddress | ICandidateAddress {
      const add:IAddress =   {
            address1: candidate.Line1,
            address2: candidate.Line2,
            city: candidate.City,
            state: candidate.State,
            zipCode: candidate.Zip,
            country: candidate.CountryName,
            countryCode: candidate.CountryISO,
            county: candidate.County,
            vdata: candidate.vData,
            latitude: candidate.Latitude,
            longitude: candidate.Longitude,
            /*countyFIPS: candidate.CountyFIPS,
            carrierRoute: candidate.CarrierRoute,
            deliveryPointCode: candidate.DeliveryPointCode,
            dpvCode: candidate.DPVCode,
            verificationStatus: candidate.RecordResultCodes
            */
        }

        if (setCandidateIndex !== null && setCandidateIndex !== undefined && Number.isInteger(setCandidateIndex)) {
            const addCan: ICandidateAddress = {...add, candidateIndex: setCandidateIndex }
            return addCan
        }
        else {
            return add
        }

    }
}

// To allow use as module (npm/webpack/etc.) export component
export {GnosisAddressCandidates, };